import React, { FC } from 'react'
import { system as s } from '@moonpig/launchpad-system'
import { styled } from '@moonpig/launchpad-utils'
import { Text } from '@moonpig/launchpad-components'
import {
  FilterCategory,
  IntegerFilter,
} from '../../../../services/types/services'
import { useFindLocaleText } from '../../../../text-localisation'
import { getAllSelectedFilters } from '../../../../utils/GalleryFiltering/getAllSelectedFilters'

const StyledSubText = styled(Text)`
  display: block;
  ${s({
    textAlign: 'left',
    color: 'colorInteractionSelectedState',
    typography: 'typeBodyCaption',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    flex: 1,
    flexGrow: 1,
  })}
`

export const SelectedFiltersList: FC<{
  filter: FilterCategory | IntegerFilter
}> = ({ filter }) => {
  const localiseText = useFindLocaleText()

  let selectedFilters: string[] = []
  if (filter.__typename === 'FilterCategory') {
    selectedFilters = getAllSelectedFilters(filter.children)
  } else if (filter.selectedValue != null && filter.selectedValueLabel) {
    selectedFilters = [filter.selectedValueLabel]
  }

  if (selectedFilters.length === 0) return null

  if (filter.isSelected && filter.__typename !== 'IntegerFilter') {
    return (
      <StyledSubText>
        {localiseText('find.all', { label: filter.label })}
      </StyledSubText>
    )
  }

  return <StyledSubText>{selectedFilters.join(', ')}</StyledSubText>
}
